import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

// ─── NASP TRACKER ─────────────────────────────────────────────────────────────

export const NaspTrackerGetRequest = (userFlag = 'All') => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTracker`,
	params: { userFlag },
	hasLoading: false,
});

export const NaspTrackerGetByIdRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTrackerById`,
	params: { id },
	hasLoading: false,
});

export const NaspTrackerGetDropdownsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTrackerDropdowns`,
	hasLoading: false,
});

export const NaspTrackerGetHistoryRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}NaspTracker/GetNaspTrackerHistory`,
	hasLoading: false,
});

export const NaspTrackerUpdateRequest = (dto) => AxiosRequest({
	method: 'PUT',
	url: `${config.API_URL}NaspTracker/UpdateNaspTracker`,
	data: dto,
	hasLoading: true,
});

export const NaspTrackerAddCommentRequest = (dto) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}NaspTracker/AddNaspTrackerComment`,
	data: dto,
	hasLoading: true,
});